"use strict";
// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
Object.defineProperty(exports, "__esModule", { value: true });
var mediaQueries = {
    "small": "480px",
    "medium": "768px",
    "large": "1200px"
};
exports.default = mediaQueries;
//# sourceMappingURL=mediaQueries.js.map